export enum ProviderTypes {
  CUSTODIAN = 'custodian',
  WALLET = 'wallet',
}
